import t from '@motional-cc/fe/tools/translate';

export const renderStatusMessage = (status?: number) => {
  return (status && t(`httpCode.name.${status}`)) || t(`httpCode.name.0`);
};
